module.exports = __webpack_public_path__ + "images/tabs/notebook-on.png";